import React from "react";
import { styled } from "styled-components";
import { popularProducts } from "../data";
import Product from "./Product";

const Products = () => {
  return (
    <Container id="products">
      {popularProducts.map((item) => (
        <Product item={item} key={item.id} />
      ))}
    </Container>
  );
};

const Container = styled.div`
  height: 100vh;
  scroll-snap-align: start;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  scroll-padding: 0 0 1000px 0;
  background: #f5fbfd;
  @media (max-width: 768px) {
    height: auto;
  }
`;

export default Products;
